import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=588e0467&"
import script from "./Cart.vue?vue&type=script&lang=ts&"
export * from "./Cart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports